import {useGetKpisByTypes} from '@domain/kpis'
import {DataContentWrapper} from '@hconnect/common/containers'
import {KpiVisibilityFlag} from '@hconnect/common/types'
import {CardBox, CardLinkWrapper} from '@hconnect/uikit/src/lib2'
import {getPlantName, useUpmPlantsContext} from '@hconnect/upm'
import {Typography, Box, SxProps, Theme} from '@mui/material'
import {PlantStatusDailyKpis, RELIABILITY_ENGINEER_KPI_TYPES} from '@widgets/kpis'
import {Link} from 'react-router'

import {useAreaDefaultPlantTimeRange} from '../hooks'
import {HierarchyRouteSegment} from '../routing'

const cardBoxPx = {xs: 2, md: 3}

export type AreaReliabilityEngineerCardContainerProps = {
  plantId: string
  cardBoxSx?: SxProps<Theme>
  kpiGridItemXs?: number
}

export const AreaReliabilityEngineerCardContainer = ({
  plantId,
  cardBoxSx,
  kpiGridItemXs
}: AreaReliabilityEngineerCardContainerProps) => {
  const upmPlants = useUpmPlantsContext()

  const {timeFrame, isLoading: isTimeRangeLoading} = useAreaDefaultPlantTimeRange({
    defaultTimeRange: 'today',
    key: 'timeRangeArea',
    plantId
  })

  const {
    data = [],
    isLoading: isKpiDataLoading,
    isError,
    isRefetching,
    refetch
  } = useGetKpisByTypes({
    plantId,
    kpiVisibilityFlag: KpiVisibilityFlag.ReliabilityEngineerEntryPoint,
    kpiTypes: RELIABILITY_ENGINEER_KPI_TYPES,
    timeFrame
  })

  return (
    <CardLinkWrapper<typeof Link> component={Link} to={`${HierarchyRouteSegment.PLANT}/${plantId}`}>
      <CardBox
        sx={{...cardBoxSx, display: 'flex', flexDirection: 'column', flex: 1, px: 0, pl: cardBoxPx}}
        data-test-id={`plant-status-kpis-card-${plantId}`}
      >
        <Typography variant="h3" mb={2}>
          {getPlantName(upmPlants, plantId)}
        </Typography>
        <DataContentWrapper
          showLoader={isTimeRangeLoading || isKpiDataLoading}
          isError={isError}
          isRefetching={isRefetching}
          retryFunction={() => void refetch()}
          data={data}
          progressSx={{color: 'primary.main'}}
        >
          <Box maxHeight={{md: 250}} sx={{overflowY: 'auto', pr: cardBoxPx}}>
            {data && (
              <PlantStatusDailyKpis kpiItems={data} gridItemXs={kpiGridItemXs} kpiSize="S" />
            )}
          </Box>
        </DataContentWrapper>
      </CardBox>
    </CardLinkWrapper>
  )
}
